import { ActionIcon, Input } from '@mantine/core'
import { IconSearch, IconX } from '@tabler/icons'
import React from 'react'

interface Props {
  search: string
  setSearch: (value: string) => void
}

export default function SearchField({ search, setSearch }: Props) {
  return (
    <Input
      placeholder="Pesquisar produto"
      icon={<IconSearch />}
      value={search}
      onChange={e => setSearch(e.target.value)}
      rightSection={
        !!search && <ActionIcon onClick={() => setSearch('')}>
          <IconX />
        </ActionIcon>
      }
    />
  )
}
